function Header() {
  return (
    <header>
      <video src="./video.mp4" loop autoPlay muted></video>
      <div className="container" align="center">
        <img src="/img/color-logo-mp-tech-1-no-bg.png" className="col-md-3" alt="" />
      </div>
      <div className="headerbg"></div>
    </header>
  );
}

export default Header;
